export const SYNC_TWR_DEVICES = '@@twrDevices/syncTwrDevices'

export const RESET_TWR_DEVICES = '@@twrDevices/reset'

export const UPDATE_TWR_DEVICES = '@@scenesList/updateTwrDevices'

export const SYNC_TWR_DEVICE_STATES = '@@twrDevices/syncTwrDeviceStates'

export const UPDATE_TWR_DEVICE_STATES = '@@scenesList/updateTwrDeviceStates'
